// src/modules/app-views/landingPages/pages/Document/tabs/BuilderTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useDocumentContext } from 'components/core/DocumentProvider';
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import LandingPageDataCard from './LandingPageDataCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const RecordTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="lpRecord" isFetching={loading} data={data} />
      <LandingPageDataCard />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default RecordTab;
